import { render, staticRenderFns } from "./LocalHero.vue?vue&type=template&id=55c7c376&"
import script from "./LocalHero.vue?vue&type=script&lang=js&"
export * from "./LocalHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports